import { RootState } from "@/redux/store";

export const selectIsAuthenticated = (state: RootState): boolean =>
  state.auth.isAuthenticated;

export const selectCurrentUser = (state: RootState) => state.auth.user;
